module.exports = __webpack_public_path__ + "static/googleIcon-9e12ceefa89fbbdcb3541acd67d98f02.svg";